import React from 'react';
import styled from 'styled-components';
import {lPad} from '../../../lib/util/CommonFunctions';
import {isMobileOnly} from 'react-device-detect';

const ProdSpecsContainerBlock = styled.div`
    padding: ${isMobileOnly?"30px 0 100px 0":"30px 0 60px 0"};
    //${!isMobileOnly&&`width: 665px;`}
`;
const ProdSpecsBlock = styled.ul`
  display: flex;
  flex-direction: column;
`;
const TitleBlock = styled.div`
    font-size: ${isMobileOnly?"16px":"18px"};
    font-weight: 500;
    color: #333333;
    margin-bottom: ${isMobileOnly?"20px":"16px"};
  
`;
const ProdSpecRowBlock = styled.li`
    display: flex;
    align-items: start;
    justify-content: flex-start;
    ${!isMobileOnly&&`
      &:last-of-type {border-bottom: 1px solid #cccccc;padding-bottom:25px;}
      &:first-of-type {border-top: 2px solid #333333;padding-top:25px;}
      `}
`;
const LabelBlock = styled.div`
    font-size: ${isMobileOnly?"13px":"14px"};
    width: ${isMobileOnly?"150px":"180px"};
    height: 100%;
    
    color: #999999;
    ${isMobileOnly?`
      margin-top: 20px;
      line-height: 1.29;
      height: 19px;
      `:`
      line-height: 1.57;
      margin: 5px 0;
      `};
    ${!isMobileOnly&&`padding-left: 35px`}
`;
const ValueBlock = styled.div`
    font-size: ${isMobileOnly?"13px":"13px"};
    width: ${isMobileOnly?"200px":"570px"};
    //height: 19px;
    color: #333333;
  ${isMobileOnly?`
      margin-top: 20px;
      line-height: 1.69;
      `:`
      line-height: 1.57;
      margin: 5px 0;      
      `};

  ${!isMobileOnly&&`padding: 0 15px`}
`;
const ProdSpecs = ({ specLabels, specValues }) => {
    return (
        <ProdSpecsContainerBlock>
            <TitleBlock>상품 정보 고시</TitleBlock>
            <ProdSpecsBlock >
                {Array(Object.keys(specValues).length).fill(1).map((el, i) =>
                  <ProdSpecRowBlock key={i}><LabelBlock>{specLabels[lPad(2,i+1)]}</LabelBlock><ValueBlock>{specValues[lPad(2,i+1)]}</ValueBlock></ProdSpecRowBlock>
                )}
            </ProdSpecsBlock>
        </ProdSpecsContainerBlock>
    );
};

export default ProdSpecs;
